import { PoItemVariant } from "./po-item-variant";

export class CompareModel {

    poNumber: string;
    poItem: number;
    size: string;
    oldPrice: string;
    newPrice: string;
    oldDeliveryDate: string;
    newDelieveryDate: string;
    oldQuantity: number;
    newQuantity: number;
    itemStatus?: string;
    itemNo?: number;
    coNumber?: string;
    coDate?: string;
    material?: string;
    buyer?: string;

    constructor(poNumber: string, poItem: number, size: string,
        oldPrice: string,
        newPrice: string,
        oldDeliveryDate: string,
        newDelieveryDate: string,
        oldQuantity: number,
        newQuantity: number,
        itemStatus?: string,
        itemNo?: number,
        coNumber?: string,
        coDate?: string,
        material?: string,
        buyer?: string,) {

        this.poNumber = poNumber
        this.poItem = poItem
        this.size = size
        this.oldPrice = oldPrice
        this.newPrice = newPrice
        this.oldDeliveryDate = oldDeliveryDate
        this.newDelieveryDate = newDelieveryDate
        this.oldQuantity = oldQuantity
        this.newQuantity = newQuantity
        this.itemStatus = itemStatus
        this.itemNo = itemNo
        this.coNumber = coNumber
        this.coDate = coDate
        this.material = material
        this.buyer = buyer

    }

}